import React, { } from "react";
import { FAQModule } from "./FAQModule";
import { HelpModule } from "./HelpModule";
import { useTitle } from "../Layout/Mobility3/Main";

export const Help: React.FC = () => {
   useTitle("Help");
   return (<>
     <HelpModule />
     <FAQModule /> 
   </>);
}